var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-color-picker',{attrs:{"predefine":_vm.palletColors,"size":"mini","disabled":_vm.disabled},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})}
var staticRenderFns = []

export { render, staticRenderFns }